import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, shareReplay } from 'rxjs';
import { GenAIProjectDto } from 'src/core/models/analysis/gen-ai-project/gen-ai-project.dto';
import { TestGenAIResponseDto } from 'src/core/models/analysis/gen-ai-project/test-gen-ai-response.dto';
import { TestGenAIRequestDto } from 'src/core/models/analysis/gen-ai-project/test-gen-ai-request.dto';
import { GenAIProjectPromptType } from 'src/core/models/enum/gen-ai-project-prompt-type.enum';
import { GenAiProjectConstants } from 'src/core/constants/gen-ai-project.constant';
import { GenAIProjectQuotaInformationDto } from 'src/core/models/analysis/gen-ai-project/gen-ai-project-quota-information.dto';

@Injectable({
  providedIn: 'root',
})
export class GenAIProjectService {
  constructor(
    private http: HttpClient,
    private genAIProjectPromptTypeEnum: GenAIProjectPromptType
  ) {}

  getByName(name: string): Observable<GenAIProjectDto> {
    const url = `${this.getApiUrl()}/by-name?name=` + encodeURIComponent(name);
    return this.http.get(url) as Observable<GenAIProjectDto>;
  }

  test(request: TestGenAIRequestDto): Observable<TestGenAIResponseDto> {
    const url = this.getApiUrl() + '/test';
    return this.http.post(url, request) as Observable<TestGenAIResponseDto>;
  }

  duplicate(id: number): Observable<GenAIProjectDto> {
    const apiUrl = `${this.getApiUrl()}/duplicate/${id}`;
    return this.http.get(apiUrl) as Observable<GenAIProjectDto>;
  }

  requestDelete(id: number): Observable<boolean> {
    const apiUrl = this.getApiUrl() + `/${id}/request-delete`;

    return this.http.put(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }) as Observable<boolean>;
  }

  getGenAIProjectQuotaInformation(): Observable<GenAIProjectQuotaInformationDto> {
    const url = this.getApiUrl() + '/quota-information';
    return this.http.get<GenAIProjectQuotaInformationDto>(
      url
    ) as Observable<GenAIProjectQuotaInformationDto>;
  }

  injectPromptTypeConstant(prompt: string, promptType: number): string {
    let promptTypeConstant = '';

    if (promptType === this.genAIProjectPromptTypeEnum.Transcript) {
      promptTypeConstant = GenAiProjectConstants.transcript;
    } else if (promptType === this.genAIProjectPromptTypeEnum.SilenceDialog) {
      promptTypeConstant = GenAiProjectConstants.silenceDialog;
    } else if (promptType === this.genAIProjectPromptTypeEnum.Hold) {
      promptTypeConstant = GenAiProjectConstants.holdTranscript;
    }

    return promptTypeConstant.length > 0
      ? `${promptTypeConstant}${GenAiProjectConstants.newLine1}${prompt}`
      : prompt;
  }

  private getApiUrl(): string {
    const apiBase = environment.apis.default.url;

    return apiBase.length > 0 ? apiBase + '/' + GenAIProjectDto.apiUrl : GenAIProjectDto.apiUrl;
  }
}
